import React, { SVGProps } from 'react';
import logo_small from "../images/logo_small.png";
import logosvg from '../images/logosvg.svg';

const Logo = (props: SVGProps<SVGSVGElement>) => (
    <img src={logosvg} className="main-logo"/>
);

export default Logo;
